<template>
  <div class="shareParent">
    <div class="poster flex-column">
      <img class="shareImg" :src="imgsrc" @click="previewImg" />
      <div hidden>
        <vue-canvas-poster :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <div class="btnView">
        <p class="shareText">{{_getBrowser() == 1 ? '点击上方图片，长按可保存图片到手机或分享':'长按上方图片，可保存图片到手机或分享'}}</p>
        <!-- <p v-else class="shareText">长按海报可进行图片分享</p> -->
        <!-- <div class="shareBtnView"> -->
          <!-- 微信端 只显示立即分享按钮 -->
          <!-- <div v-if="_getBrowser()==1" @click="previewImg" class="shareBtn shareBtn2">
            <p class="shareBtnText">查看海报</p>
          </div> -->
          <!-- <div @click="shareLink" class="shareBtn">
            <p class="shareBtnText">立即分享</p>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import CanvasPoster from "vue-canvas-poster";
import OverlayModal from "../components/OverlayModal.vue";
import { Overlay } from "vant";
import config from "../config.js";
import Phone from "../components/Phone.vue";
Vue.use(Overlay);
Vue.use(CanvasPoster, OverlayModal);
export default {
  name: "Share",
  components: { OverlayModal, Phone },
  data() {
    return {
      imgsrc: "",
      painting: {},
      showmodal: false, //分享遮罩
      showshare: true,
      isphone: false,
      params:{
        vowtext:'# 武汉加油！我们一起打赢这场仗！中国加油！ #',
        place:'大不列颠及北爱尔兰联合王国大不列颠及北爱',
        zCount:"14141551"
      }
    };
  },
  mounted() {
    var t = this;
    console.log("vowtext",t.$route.query);
    var q = t.$route.query
    q.vowtext = decodeURIComponent(q.vowtext)
    if(q.mypost){
      q.mypost = decodeURIComponent(q.mypost)
      this.imgsrc = q.mypost;
    }else{
      q.mypost =  ''
    }

    t.params={
      vowtext:q.vowtext||'# 武汉加油！我们一起打赢这场仗！中国加油！ #',
      place:q.place||'',
      zCount:t.wishTotal.toString(),
      postid:q.postid || 0
    };
    if(!q.mypost){
      this.getBaseUser();
    }
    
  },
  methods: {
    //海报生成成功回调
    success(src) {
      this.imgsrc = src;
    },
    //海报生成失败回调
    fail(err) {
      console.log(err);
    },
    //获取用户基本信息
    async getBaseUser() {
      var t = this;
      var userid = 0;
      var app_login_user = localStorage.getItem(config.login_key);
      if (app_login_user) app_login_user = JSON.parse(app_login_user);
      if (app_login_user.userid) {
        userid = app_login_user.userid;
      }
      var code_url = `${t._getInitUrl().roothref}index.html#/?a=${t._getAPPParams().activity_id}&channel=${t._getBrowser() == 1 ? 'jegotripapp' : 'wechat'}`;
      console.warn(code_url);
      t.url = code_url; //二维码链接地址
      t.vowText = t.params.vowtext; //愿望文本
      t.place = t.params.place; //地址
      t.zCount = t.params.zCount; //祈福人数
      t.avatar = require("../../static/images/logo.jpg"); //默认头像
      t.nickname = ""; //默认昵称
      t.vowImg = require('../../static/images/poster'+ t.params.postid +'.jpg'); //海报背景
      t.addIcon = require("../../static/images/location_icon@2x.png"); //定位图标
      //
      // t.vowText = "计算愿望长度，中文两个字符占位";
      var Vlen = 0; //计算愿望长度，中文两个字符占位，英文数字一个字符占位
      for (var i = 0; i < t.vowText.length; i++) {
        if ((t.vowText.charCodeAt(i) & 0xff00) != 0) {
          Vlen++;
        }
        if(/[il]+/.test(t.vowText[i])) Vlen-=0.45;
        if(/[w]+/ig.test(t.vowText[i])) Vlen+=0.45;
        Vlen++;
      }
      t.place ="      "+t.place;
      var Plen = 0; //计算地址长度，中文两个字符占位，英文数字一个字符占位
      var PPlen = 0;
      for (var i = 0; i < t.place.length; i++) {
        if ((t.place.charCodeAt(i) & 0xff00) != 0) {
          Plen++;
        }
        if(/[il]+/.test(t.place[i])) Plen-=0.45;
        if(/[w]+/ig.test(t.place[i])) Plen+=0.45;
        if(t.place[i]==' ') PPlen+=1;
        Plen++;
      }
      console.log("vlen",Vlen)
      console.log("Plen",Plen)
      var params = {
        rec_uid: t._getAPPParams().share_userid,
        activity_id: t._getAPPParams().activity_id
      };
      await t._signup("user", "User.getUserInfo", params).then(res => {
        if (res.status == 0) {
          var myuser = res.data.user;
          if (myuser.avatar && myuser.avatar != 0) {
              // t.avatar = 'https://h5un.oss-cn-shenzhen.aliyuncs.com/img/logo2.31f3e47c.png';
              // t.avatar = 'http://jtoss.jegotrip.com.cn/socialcontact/usermood/3041034/795a26c7-fbb5-4e8e-9c04-4fc52d5e8d0d.jpg';
              t.avatar = myuser.avatar.replace("http", "https");
              // t.avatar = t._getBrowser() == 2 ? myuser.avatar.replace("http", "https") : myuser.avatar;
            }
          if (myuser.nickname) t.nickname = myuser.nickname;
        }
      });
      var painting_view = [];
      //背景图
      painting_view.push({type: "image",url: t.vowImg,left: 0,top: 0,width: 669,height: 1148});
      //头像
      painting_view.push({type: "image",url: t.avatar,left: 34,top: 39,width: 68, height: 68,radius: 34});
      //昵称
      painting_view.push({type: "text",content: t.nickname,fontSize: 34, bolder: false,top: 52,left: 116,width: 490,lineHeight: 34,color: "#E0B8B3",breakWord: false, MaxLineNumber: 1});
      //祈福内容
      painting_view.push({type: "text",content: t.vowText,fontSize: 36, bolder: true,top: 131,left: 37,width: 550,lineHeight: 48,color: "#FFF0C6", textAlign: "left",breakWord: true, MaxLineNumber: 2});
      

      if(t.place && t.place.length>6)
      {
        //祈福地址
        var add_top = 188;
        if(Vlen>32) add_top += 48;
        painting_view.push({type: "image",url: t.addIcon,left: 34,top: add_top+11,width: 18, height: 20});
        painting_view.push({type: "text",content: "我在",fontSize: 20, bolder: false,top: add_top+8,left: 62,width: 60,lineHeight: 35,color: "#ffffff", textAlign: "left",breakWord: false, MaxLineNumber: 1});
        painting_view.push({type: "text",content: t.place,fontSize: 28, bolder: false,top: add_top,left: 62,width: 413,lineHeight: 35,color: "#ffffff", textAlign: "left",breakWord: true, MaxLineNumber: 2});
        var addend_left = 62 + (Plen%34)*14+8;
        if(Plen<34) addend_left = 62 + (Plen-PPlen)*14 + PPlen*0.62*14+8;
        console.log("addend_left",addend_left)
        var addend_top = add_top + Math.floor(Plen/34)*35;
        painting_view.push({type: "text",content: "祈福",fontSize: 20, bolder: false,top: addend_top+8,left: addend_left,width: 60,lineHeight: 35,color: "#ffffff", textAlign: "left",breakWord: false, MaxLineNumber: 1});
      }
      //二维码
      painting_view.push({type: "rect",backgroundColor: "#ffffff",left: 521,top: 891,width: 117,height: 116 });
      painting_view.push({type: "qrcode",content: t.url,background: "#ffffff",color: "#000000",left: 528,top: 897,width: 104,height: 104 });
      painting_view.push({type: "image",url: t.avatar,left: 528+104/2-22/2,top: 897+104/2-22/2,width: 22, height: 22,radius: 0});
      
      //祈福人数
      painting_view.push({type: "text",content: "已有",fontSize: 24, bolder: false,top: 1094,left: 29,width: 60,lineHeight: 35,color: "#FFF0C6", textAlign: "left",breakWord: false, MaxLineNumber: 1});
      painting_view.push({type: "text",content: t.zCount,fontSize: 46, bolder: true,top: 1074,left: 89,width: 500,lineHeight: 46,color: "#FAC137", textAlign: "left",breakWord: false, MaxLineNumber: 1});
      painting_view.push({type: "text",content: "人为武汉祈福",fontSize: 24, bolder: false,top: 1094,left: 89+t.zCount.length * 25 +15,width: 60,lineHeight: 35,color: "#FFF0C6", textAlign: "left",breakWord: false, MaxLineNumber: 1});
      
      var painting = {
        width: 669,
        height: 1148,
        views: painting_view
      };
      t.painting = painting;
    },
    //分享链接
    shareLink() {
      this._deepmain(this.pageId, "poster#shareclick", 2);
      if (this._getBrowser() == 1) {
        this._sharelink();
      } else {
        if (this.myUserInfo.isbindtel == 0) {
          this.isphone = true;
          return;
        }
        this.showmodal = true;
      }
    },
    //app预览海报
    previewImg() {
      try {
        Jegotrip.articlePictureShareResp(this.imgsrc);
        this._deepmain(this.pageId, "poster#posterpic", 2);
      } catch (e) {}
    },
    //遮罩层控制
    controlOverlay(status) {
      this.showmodal = status;
    }
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/share.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>